export default {
  options: {},
  customFields: undefined,
  company: undefined,
  embedId: undefined,
  active: false,
  settings: undefined,
  filterAgents: undefined,
  parentUrl: '',
  form: undefined,
  fetchingForm: false,
  ready: false,
  onFocus: true,
  organization: undefined,
  subDomainStatus: undefined,
  hiding: false,
  culture: undefined,
  whitelabel: false
}
